// client/src/pages/ContactPage.js
import React, { useState } from 'react';

const CLIENT_TYPES = ['Buyer', 'Seller', 'Tenant', 'Landlord'];

const ContactPage = () => {
    const [formData, setFormData] = useState({ name: '', email: '', phone: '', client_type: 'Buyer', message: '', website: '' });
    const [status, setStatus] = useState('idle'); // idle | submitting | success | error
    const [error, setError] = useState('');

    const handleChange = (e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('submitting');
        setError('');
        try {
            const response = await fetch('/api/public/lead-capture', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.message || 'Something went wrong.');
            setStatus('success');
        } catch (err) {
            setError(err.message);
            setStatus('error');
        }
    };

    if (status === 'success') {
        return (
            <div className="container mx-auto px-6 py-20 text-center">
                <div className="max-w-2xl mx-auto">
                    <h1 className="text-4xl font-bold mb-6">Thank You</h1>
                    <p className="text-lg text-gray-700">We've received your message and will be in touch soon.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="container mx-auto px-6 py-20">
            <div className="max-w-2xl mx-auto">
                <h1 className="text-4xl font-bold mb-6 text-center">Contact Us</h1>
                <p className="text-lg text-gray-700 mb-8 text-center">
                    Ready to discuss your real estate needs? Send us a message and our team will follow up. Please refer to our compliance information in the footer for our Designated Managing Broker's contact details.
                </p>
                <form onSubmit={handleSubmit} className="space-y-4 bg-white p-8 rounded-lg shadow">
                    {/* Honeypot field — hidden from real visitors via CSS, bots often fill it in anyway */}
                    <input
                        type="text"
                        name="website"
                        value={formData.website}
                        onChange={handleChange}
                        tabIndex="-1"
                        autoComplete="off"
                        style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px' }}
                        aria-hidden="true"
                    />
                    <input name="name" value={formData.name} onChange={handleChange} placeholder="Full Name" required className="w-full p-3 border rounded-md" />
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <input name="email" type="email" value={formData.email} onChange={handleChange} placeholder="Email" className="w-full p-3 border rounded-md" />
                        <input name="phone" type="tel" value={formData.phone} onChange={handleChange} placeholder="Phone" className="w-full p-3 border rounded-md" />
                    </div>
                    <select name="client_type" value={formData.client_type} onChange={handleChange} className="w-full p-3 border rounded-md">
                        {CLIENT_TYPES.map(t => <option key={t} value={t}>I am a {t}</option>)}
                    </select>
                    <textarea name="message" value={formData.message} onChange={handleChange} placeholder="How can we help?" rows="4" className="w-full p-3 border rounded-md"></textarea>
                    {error && <p className="text-red-500 text-sm">{error}</p>}
                    <button type="submit" disabled={status === 'submitting'} className="w-full px-8 py-4 text-lg text-white bg-slate-800 rounded-lg hover:bg-slate-900 disabled:bg-indigo-400">
                        {status === 'submitting' ? 'Sending...' : 'Send Message'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ContactPage;
